import React, { useEffect, useState } from 'react'
import App from '../components/App'
import TopNav from '../components/organisms/TopNav/TopNav'
import Container from '@/components/Container'
import Main from '@/components/Main'
import Section from '@/components/Section'
import { AppContextProvider } from '@/components/AppContextProvider'
import styled from 'styled-components'
import HomePageHero from '../components/organisms/HomePageHero/HomePageHero'
import HowItWorks from '@/components/organisms/HowItWorks/HowItWorks'
import ForTreatmentProviders from '@/components/ForTreatmentProviders/ForTreatmentProviders'
import ConditionsCarousel from '@/components/ConditionsCarousel/ConditionsCarousel'
import InsuranceCarousel from '@/components/InsuranceCarousel/InsuranceCarousel'
import LocationsCarousel from '@/components/LocationsCarousel/LocationsCarousel'
import ATrustedRecoveryLeader from '@/components/ATrustedRecoveryLeader/ATrustedRecoveryLeader'
import OurValues from '@/components/organisms/OurValues/OurValues'
import BrowseBy from '@/components/organisms/BrowseBy/BrowseBy'
import ResourceLibrarySection from '@/components/organisms/ResourceLibrarySectionV2/ResourceLibrarySection.tsx'
import { generateSocialTags } from '../domain/seo/useCases/generateSocialTags.js'
import MetaData from '../components/SEO/MetaData.js'
import FeaturedCentersNearYou from '@/components/organisms/FeaturedCenters/FeaturedCentersNearYou.jsx'
import getUserGeo from '../lib/getUserGeo.js'
import { setSessionStorage } from '../utils/sessionStorage'
import schemaData from '@/utils/schema/homePageSchema'

const pageType = 'Home'
const HomePage = styled.div``

const IndexPage = ({ parentProps }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({
      pageType
    })
  }

  const pageTitle = 'Recovery.com: Find Addiction & Mental Health Treatment'
  const pageDescription = `We independently research each addiction and mental health treatment center to help you find the best rehab center in the world for you.`
  const canonicalLink = 'https://recovery.com'

  const socialTagsData = generateSocialTags(
    pageTitle,
    pageDescription,
    'website',
    'https://recovery.com',
    'https://res.cloudinary.com/rehabpath/image/upload/v1721399482/og-image-recovery-com.jpg'
  )

  const [userCountryCode, setUserCountryCode] = useState(undefined)

  useEffect(() => {
    const fetchUserCountryCode = async () => {
      const userGeo = await getUserGeo()
      setUserCountryCode(userGeo?.country_code)
    }
    fetchUserCountryCode()
    setSessionStorage('searchState', null)
  }, [])

  const isUserFromUS = userCountryCode === 'US' || !userCountryCode

  return (
    <HomePage>
      <AppContextProvider
        value={{
          breadcrumbs: pageType,
          pageType
        }}
      >
        <App
          home
          pageType={pageType}
          showBreadCrumbs={false}
          footerClassName="!mt-0"
        >
          <MetaData
            pageTitle={pageTitle}
            pageDescription={pageDescription}
            canonicalLink={canonicalLink}
            socialTagsData={socialTagsData}
            schemaData={schemaData}
          />
          <TopNav
            home
            transparent
            pageType={parentProps?.pageType}
            title={parentProps?.title}
            breadcrumbs={parentProps?.breadcrumbs}
            pageContext={
              parentProps?.children?.props?.searchState?.refinementList
            }
            hideSearchHeaderMobile
          />
          <HomePageHero pageContext={parentProps?.pageContext} />
          <Main className="space-y-16 !pb-0 pt-16 sm:space-y-20 sm:py-14 xl:space-y-28 xl:py-20">
            <FeaturedCentersNearYou />

            <Section>
              <Container>
                <ConditionsCarousel />
              </Container>
            </Section>

            <Section>
              <Container>
                <ATrustedRecoveryLeader />
              </Container>
            </Section>

            <Section>
              <Container>
                <HowItWorks />
              </Container>
            </Section>

            {isUserFromUS && (
              <Section>
                <Container>
                  <InsuranceCarousel />
                </Container>
              </Section>
            )}

            <Section>
              <Container>
                <LocationsCarousel />
              </Container>
            </Section>

            <Section>
              <Container>
                <ResourceLibrarySection />
              </Container>
            </Section>

            <Section>
              <Container>
                <OurValues />
              </Container>
            </Section>

            <Section>
              <Container>
                <ForTreatmentProviders />
              </Container>
            </Section>

            <Section className="bg-stone-50">
              <Container>
                <BrowseBy />
              </Container>
            </Section>
          </Main>
        </App>
      </AppContextProvider>
    </HomePage>
  )
}

export default IndexPage
